<template>
  <div class="app-loader__container">
    <div class="gantt">
      <div class="gantt__bar">
        <div class="gantt__bar__inner is-1" />
      </div>

      <div class="gantt__bar">
        <div class="gantt__bar__inner is-2 offset-1" />
      </div>

      <div class="gantt__bar">
        <div class="gantt__bar__inner is-3 offset-1" />
      </div>

      <div class="gantt__bar">
        <div class="gantt__bar__inner is-2 offset-2" />
      </div>

      <div class="gantt__bar">
        <div class="gantt__bar__inner is-1 offset-1" />
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss">
.app-loader__container {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;

  .gantt {
    position: relative;
    box-sizing: content-box;
    height: 115px;
    width: 115px;
    font-size: 0;
    border: 7px solid #dddddd;
    padding: 10px;
    display: inline-block;
    border-radius: 50%;
    overflow: hidden;

    &::after {
      content: '';
      box-sizing: border-box;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      border: 5px solid white;
      border-radius: 50%;
    }

    &__bar {
      height: 15px;
      margin-bottom: 10px;
      transform-origin: left center;
      animation: grow-bar 1.5s linear forwards infinite;
      display: inline-block;
      transform: translateX(-100%);
      opacity: 0;

      &:last-child {
        margin: 0;
      }

      &__inner {
        background: #dddddd;
        height: 100%;
        border-radius: 10px;

        &.is-1 { width: 50px }
        &.is-2 { width: 100px }
        &.is-3 { width: 150px }
        &.offset-1 { margin-left: 50px; }
        &.offset-2 { margin-left: 100px; }
        &.offset-3 { margin-left: 150px; }
        &.offset-4 { margin-left: 200px; }
      }

      @for $i from 1 through 5 {
        &:nth-child(#{$i}) { animation-delay: #{($i - 1)/2}s }
      }
    }
  }

  @keyframes grow-bar {
    0% {
      opacity: 0;
      transform: translateX(-100%);
    }
    50% {
      opacity: 1;
      transform: translateX(0);
    }
    80% {
      opacity: 1;
      transform: translateX(20%);
    }
    100% {
      opacity: 0;
      transform: translateX(50%);
    }
  }
}
</style>
